import { useEffect, useState } from 'react';
import { fetchDaily, type DailyResponse } from '../api';

export function DailyCard() {
  const [data, setData] = useState<DailyResponse | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    fetchDaily()
      .then(setData)
      .catch((e) => setErr(String(e)));
  }, []);

  if (err) return <div className="card muted">— {err}</div>;
  if (!data) return <div className="card muted">…</div>;

  return (
    <div className="card">
      <div className="accent" style={{ fontWeight: 600, marginBottom: 4 }}>
        {data.signName}
      </div>
      <div className="muted" style={{ marginBottom: 8 }}>
        {data.date}
      </div>
      <div className="daily-reading">{data.reading}</div>
    </div>
  );
}
